import { GetServerSideProps } from 'next'

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.write('status=active')
  res.end()
  return { props: {} }
}

const Ping = () => <div />
export default Ping
